import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { primeHoldingConstants } from "./primeHoldingConstants";

const initialState = {
    primeHoldingList: [],
    loading: {
        primeHoldingList: 0,
    },
};

export const primeHoldingReducers = persistReducer(
    {
        storage,
        key: "primeHolding",
        blacklist: ["loading"],
    },
    (state = initialState, { type, payload }) => {
        switch (type) {

            case primeHoldingConstants.PRIME_HOLDING_REQUEST: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        primeHoldingList: 1,
                    },
                    primeHoldingList: initialState.primeHoldingList,
                };
            }

            case primeHoldingConstants.PRIME_HOLDING_RESPONSE: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        primeHoldingList: 0,
                    },
                    primeHoldingList: payload,
                };
            }

            default:
                return state;
        }
    }
);
